module.exports = __webpack_public_path__ + "static/media/loader-icon.7b311951.svg";